import gql from 'graphql-tag'

export const fetchProductsQuery = gql`
  query (
    $sku: [String]
    $search: String
    $sort: ProductAttributeSortInput
    $brand: [String]
    $category_id: [String]
    $category_uid: [String]
    $sap_sub_brand_code: [String]
    $country_of_origin:[String]    
    $packaging: [String]
    $volume: [String]
    $pack_format: [String]
    $currentPage: Int!
    $pageSize: Int = 25
    $product_last: String
    $product_new: String
    $low_stock: String,
    $imported_beers: String,
    $international: String,
    $returnable: String,
    $product_sale: String
    $runner_type: [String]
  ) {
    products(
      search: $search
      filter: {
        sku: { in: $sku }
        brand: { in: $brand }
        pack_format: {in : $pack_format}
        sap_sub_brand_code: { in : $sap_sub_brand_code}
        country_of_origin:{ in: $country_of_origin }
        category_id: { in: $category_id }
        category_uid: { in: $category_uid }
        packaging: { in: $packaging }
        volume: { in: $volume }
        product_last: { eq: $product_last }
        product_new: { eq: $product_new }
        low_stock: { eq: $low_stock }
        imported_beers: { eq: $imported_beers }
        international: { eq: $international }
        returnable: { eq: $returnable }
        product_sale: { eq: $product_sale }
        runner_type:{ in: $runner_type }
      }
      pageSize: $pageSize
      currentPage: $currentPage
      sort: $sort
    ) {
      total_count
      items {
        multi_deposit
        material_type
        number_of_items_in_box
        sap_sub_brand_code
        alcohol_content
        dimension
        runner_type
        name
        deliveryDate
        sku
        your_price
        your_price_tax
        favourites
        promo
        product_last
        product_new
        low_stock
        imported_beers
        international
        returnable
        product_sale
        number_of_products_on_layer
        number_of_items_on_pallet
        number_of_layers_per_pallet
        number_of_bottles
        pack_format
        description {
          html
        }
        small_image {
          url
        }
        cart_fields {
          packaging_cart
          layer_cart
          pallets_cart
        }
        ... on BundleProduct {
          your_price_sum
          your_price_sum_tax
          bundle_price_sum
          bundle_price_sum_tax
          bundle_fields {
            minimum_amt
            valid_from
            valid_to
            limited_amount
          }
          items {
            option_id
            title
            sku
            type
            required
            position
            your_price_sum
            your_price_sum_tax
            options {
              uid
              id
              label
              quantity
              can_change_quantity
              price
              price_type
              is_default
              position
              product {
                id
                name
                sku
                price_range {
                  minimum_price {
                    regular_price {
                      value
                      currency
                    }
                  }
                }
                your_price
                your_price_tax
              }
            }
          }
        }
      }
      page_info {
        page_size
        total_pages
        current_page
      }
    }
  }
`
